import { render, staticRenderFns } from "./generatedForms.vue?vue&type=template&id=959b7ff8"
import script from "./generatedForms.js?vue&type=script&lang=js&external"
export * from "./generatedForms.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports